import { useState, useEffect, useRef } from 'react';

export const debounce = (func, wait) => {
    let timeout;
    return function(...args) {
        const context = this;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
}

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

export const useDebounceCallback = (callback, delay) => {
    const latestCallback = useRef();
    const [callCount, setCallCount] = useState(0);
  
    useEffect(() => {
        latestCallback.current = callback;
    }, [callback]);
  
    useEffect(() => {
        if (callCount > 0) {
            const fire = () => {
                setCallCount(0);
                latestCallback.current();
            };
            const id = setTimeout(fire, delay);
            return () => clearTimeout(id);
        }
    }, [callCount, delay]);
  
    return () => setCallCount(callCount => callCount + 1);
};